/**
 * WBC Booster Club quiz answer bridge.
 *
 * Omnisend does not persist a navigation-only choice made before an email is
 * collected. This listener remembers the selected answer, then attaches it to
 * the contact as an Omnisend custom event after the form is submitted.
 */
(function () {
  'use strict';

  var FORM_ID = '6a824d32f6bc52c14571cfc4';
  var EVENT_NAME = 'booster_club_belief_selected';
  var STORAGE_KEY = 'wbc_booster_club_belief';
  var SENT_KEY = 'wbc_booster_club_belief_sent';

  var ANSWERS = {
    'THIS COULD BE THE YEAR.': 'this_could_be_the_year',
    "I'VE SEEN THE EVIDENCE.": 'seen_the_evidence',
    "I'M RAISING THE NEXT GENERATION.": 'raising_next_generation',
    "I DON'T. THE GEAR'S JUST GOOD.": 'gear_is_just_good'
  };

  var BUTTON_ANSWERS = {
    'omnisend-form-6a824d32f6bc52c14571cfc4-action-6a825e46e080d6c53735ca0f': 'this_could_be_the_year',
    'omnisend-form-6a824d32f6bc52c14571cfc4-action-6a825e46e080d6c53735ca10': 'seen_the_evidence',
    'omnisend-form-6a824d32f6bc52c14571cfc4-action-6a825e46e080d6c53735ca11': 'raising_next_generation',
    'omnisend-form-6a824d32f6bc52c14571cfc4-action-6a825e46e080d6c53735ca12': 'gear_is_just_good'
  };

  function normalize(value) {
    return String(value || '')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function readStoredAnswer() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function storeAnswer(label, value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        label: label,
        value: value,
        selectedAt: new Date().toISOString()
      }));
      window.sessionStorage.removeItem(SENT_KEY);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes. The form still works.
    }
  }

  function selectedAnswerFromClick(target) {
    var button = target && target.closest ? target.closest('button') : null;
    if (!button) return null;

    var formRoot = button.closest('[id*="' + FORM_ID + '"]');
    if (!formRoot) return null;

    var fullText = normalize(button.textContent);
    var value = BUTTON_ANSWERS[button.id];
    var label = '';

    Object.keys(ANSWERS).some(function (answerLabel) {
      if (fullText.indexOf(answerLabel) === 0) {
        label = answerLabel;
        value = value || ANSWERS[answerLabel];
        return true;
      }
      return false;
    });

    return value ? { label: label || fullText, value: value } : null;
  }

  document.addEventListener('click', function (event) {
    var answer = selectedAnswerFromClick(event.target);
    if (answer) storeAnswer(answer.label, answer.value);
  }, true);

  window.addEventListener('omnisendForms', function (event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.name !== 'formSubscriberIdentified' || !detail.email) return;

    var answer = readStoredAnswer();
    if (!answer || !answer.value) return;

    try {
      if (window.sessionStorage.getItem(SENT_KEY) === answer.value) return;
    } catch (error) {
      // Continue without duplicate protection when storage is unavailable.
    }

    window.omnisend = window.omnisend || [];
    window.omnisend.push([
      'track',
      EVENT_NAME,
      {
        contact: { email: detail.email },
        origin: 'api',
        properties: {
          belief_segment: answer.value,
          answer_label: answer.label,
          form_id: FORM_ID,
          form_name: 'Booster Club Multi-Choice Email Sign-up'
        }
      }
    ]);

    try {
      window.sessionStorage.setItem(SENT_KEY, answer.value);
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // The event was queued; storage cleanup is optional.
    }
  });
})();
